export const EMPTY_ARRAY = [];
export const PAGE_LIMIT = 10000;
